import jump from 'jump.js'

export default birthday => {
  let jumpLink = document.querySelector('.js-explore-birthday')
  jumpLink.addEventListener('click', () => {
    jump('.birthday-product-container', {
      offset: -200
    })
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/snowe-birthday-2020.js